import { render } from "./DropFile.vue?vue&type=template&id=f3637818"
import script from "./DropFile.vue?vue&type=script&lang=js"
export * from "./DropFile.vue?vue&type=script&lang=js"

import "./DropFile.vue?vue&type=style&index=0&id=f3637818&scope=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__